import OResponseFlowSettingList from './index.vue';

OResponseFlowSettingList.install = app => {
  app.component(OResponseFlowSettingList.name, OResponseFlowSettingList);
};

export default OResponseFlowSettingList;
